import { TextChunkBlockSupportingAsset } from 'api/graphql/generated';

const supportingAsset = (asset: TextChunkBlockSupportingAsset) => {
  if (!asset) return null;

  return {
    src: asset.__typename === 'Icon' ? asset.svg.url : asset.file.url,
    alt: asset.__typename === 'Icon' ? asset.svg.description : asset.file.description,
    width: asset.__typename === 'Icon' ? asset.svg.width : asset.file.height,
    height: asset.__typename === 'Icon' ? asset.svg.width : asset.file.height,
  };
};

export { supportingAsset };
